function toggle(element) {

    var countrySelectorsParam = element, index;
    
   for (index = 0; index < countrySelectorsParam.length; ++index) {
     
  
      if(element[index].hasAttribute('hidden', true)) {
          element[index].removeAttribute('hidden');
        element[index].style.display = 'block';
      } else { 
          element[index].setAttribute('hidden', true);
        element[index].style.display = 'none';
      }
   }
  }
